<template>
  <div class="age">
    <table>
      <thead>
        <tr>
          <td><span class="mini-font strong">AGE</span></td>
          <td><span class="mini-font strong">TRAFFIC</span></td>
        </tr>
      </thead>
      <tbody v-if="age">
        <tr v-for="(item, index) in age" :key="index">
          <td><span class="subhead">{{item.type}}</span></td>
          <td><span class="subhead">{{item.traffic | formatNumber}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'adx-dashboard-campaignreport-age',
  components: {

  },
  props: {

  },
  data() {
    return {
      age: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.age = this.$parent._data.dataDemographic.age
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
